const en = {
    'App.Title': 'OKICABusiness',
    'App.Account': 'Account',
    'App.AccountClose': 'AccountClose',

    // �����̕\���t�H�[�}�b�g
    'DateFormat.LongDateTime': 'DD/MMM/YYYY HH:mm',
    'DateFormat.ShortDateTime': 'DD/MMM HH:mm',
    'DateFormat.Time': 'HH:mm',

    'Profile.Title': 'Profile',
    'Profile.UserName': 'User Name',
    'Profile.Email': 'Email',
    'Profile.Role': 'Role',

    //Error Message
    'Error.Unauthorized': 'Login status is invalid. Please login again.',
    'Error.Forbidden': 'User does not have required permissions',
    'Error.InternalServerError': 'There was a problem during processing.',
    'Error.BadRequest': 'Invitation_is_already_completed.',
    'Error.Required': 'Required',
    'Error.KatakanaName': 'Please enter katakana characters',
    'Error.Number': 'Please enter a number',
    'Error.HankakuNumber': 'Please enter half- width numbers.',
    'Error.Hankakueisu': 'Please enter half-width alphanumeric characters.',
    'Error.Email': 'Bad email address format',
    'Error.EnglishName': 'Please enter english alphabet',
    'Error.Length': 'Exceeded maximum allowed length',
    'Error.DecimalNumber': 'Two digits for the integer part and one digit for the fractional part.',
    'Error.Range': 'The number must be within 0 to 100 range.',

    'Error.FeeMaxLen': 'Enter up to 6 characters.',
    'Error.FeeMin': 'Please enter 0.00 or more.',
    'Error.FeeMax': 'Please enter less than 100.00',
    'Error.FeePattern': 'Please enter between 0.00 and 100.00',

    'Error.PointNameMaxLen': 'Enter up to 50 characters.',
    'Error.PointMaxLen': 'Enter up to 5 characters.',
    'Error.PointMin': 'Please enter 0.0 or more.',
    'Error.PointMax': 'Please enter less than 100.0',
    'Error.PointPattern': 'Enter 2 digits for the integer part and 1 digit for the fractional part or less, and use one- byte numbers from 0.0 to 100.0.',

    'Error.ShopCd1_Pattern': 'Please enter a 13-digit half- width number.',
    'Error.ShopCd2_Pattern': 'Please enter a 4-digit half- width number.',
    'Error.ShopCd3_Pattern': 'Please enter a 6-digit half- width number.',
    'Error.ShopCd4_Pattern': 'Please enter a 6-digit half- width number.',


    'Error.ShopLonMinPattern': 'Longitude: Enter 123.000000 or higher.',
    'Error.ShopLonMaxPattern': 'Longitude: Please enter less than 154.000000',
    'Error.ShopLatMinPattern': 'Latitude: Please enter at 20.000000 or higher.',
    'Error.ShopLatMaxPattern': 'Latitude: Please enter 45.000000 or less.',

    'Error.TerminalInstallIdPattern': 'Enter the 17-digit alphanumeric value of the first letter M.',

    'Error.TerminalMerchantOrgInfoPattern': 'Enter up to 20 characters.',

    'Error.ShopName1MaxLenPattern': 'Enter up to 50 characters.',
    'Error.ShopName2MaxLenPattern': 'Enter up to 100 characters.',
    'Error.ShopPostalMinLenPattern': 'Enter 7 characters.',
    'Error.ShopPostalMaxLenPattern': 'Enter up to 7 characters.',
    'Error.ShopAdressMaxLenPattern': 'Enter up to 255 characters.',
    'Error.ShopLatLonMaxLenPattern': 'Enter up to 6 decimal places.',
    'Error.ShopLatLonPattern': 'Enter notation in world geodetic system.',
    'Error.ShopTelFaxMinLenPattern': 'Enter 10 characters.',
    'Error.ShopTelFaxMaxLenPattern': 'Enter up to 12 characters.',
    'Error.ShopDealInfoMaxLenPattern': 'Enter up to 500 characters.',

    'Error.AccountEmailPattern': 'Enter up to 256 characters.',
    'Error.AccountNamePattern': 'Enter up to 128 characters.',
    'Error.AccountPassWordPattern': 'Must be at least 8 characters and contain at least 3 of uppercase letters(A- Z), lowercase letters (a - z), numbers(0 - 9), and special characters(!@#$%^&*, etc.).There is.',
    'Error.AccountPassWordMatchPattern': 'Passwords do not match.',

    'Error.AcquirerContactNameMaxLenPattern': 'Enter up to 50 characters.',
    'Error.AcquirerContactDepartMaxLenPattern': 'Enter up to 40 characters.',
    'Error.AcquirerTelMinLenPattern': 'Please enter at least 10 characters.',
    'Error.AcquirerTelMaxLenPattern': 'Enter up to 12 characters.',
    'Error.AcquirerEmailMaxLenPattern': 'Enter up to 256 characters.',
    'Error.AcquirerCorporatNameMaxLenPattern': 'Enter up to 50 characters.',
    'Error.AcquirerCorporatNoMinLenPattern': 'Please enter 12 characters.',
    'Error.AcquirerCorporatNoMaxLenPattern': 'Enter up to 12 characters.',
    'Error.AcquirerMerchantNameMaxLenPattern': 'Enter up to 25 characters.',
    'Error.AcquirerMerchantEnglishNameMaxLenPattern': 'Enter up to 100 characters.',

    'Error.AcquirerMerchantPostalMinLenPattern': 'Please enter 7 characters.',
    'Error.AcquirerMerchantPostalMaxLenPattern': 'Enter up to 7 characters.',
    'Error.AcquirerMerchantAdressMaxLenPattern': 'Enter up to 100 characters.',
    'Error.AcquirerMerchantTelFaxMinLenPattern': 'Enter up to 10 characters.',
    'Error.AcquirerMerchantTelFaxMaxLenPattern': 'Enter up to 12 characters.',
    'Error.AcquirerMerchantCapitalMaxLenPattern': 'Enter up to 9 characters.',
    'Error.AcquirerMerchantAnnualSaleMaxLenPattern': 'Enter up to 9 characters.',
    'Error.AcquirerMerchantEmployeesNumberMaxLenPattern': 'Enter up to 5 characters.',
    'Error.AcquirerMerchantTempNumberMaxLenPattern': 'Enter up to 4 characters.',
    'AcquirerMerchantBusinessContentMaxLenPattern': 'Enter up to 500 characters.',

    'Error.AcquirerDelegateNameMaxLenPattern': 'Enter up to 50 characters.',
    'Error.AcquirerDelegatePostalMinLenPattern': 'Please enter 7 characters.',
    'Error.AcquirerDelegatePostalMaxLenPattern': 'Enter up to 7 characters.',
    'Error.AcquirerDelegateAdressMaxLenPattern': 'Enter up to 100 characters.',
    'Error.AcquirerDelegateTelMinLenPattern': 'Enter up to 10 characters.',
    'Error.AcquirerDelegateTelMaxLenPattern': 'Enter up to 12 characters.',

    'Error.AcquirerFinancialNameMaxLenPattern': 'Enter up to 50 characters.',
    'Error.AcquirerFinancialCdMinLenPattern': 'Please enter 4 characters.',
    'Error.AcquirerFinancialCdMaxLenPattern': 'Enter up to 4 characters.',
    'Error.AcquirerFinancialBranchNameMaxLenPattern': 'Enter up to 50 characters.',
    'Error.AcquirerFinancialBranchNoMaxLenPattern': 'Enter up to 3 characters.',
    'Error.AcquirerFinancialAccountNoMinLenPattern': 'Please enter 7 characters.',
    'Error.AcquirerFinancialAccountNoMaxLenPattern': 'Enter up to 7 characters.',
    'Error.AcquirerFinancialAccountHolderMaxLenPattern': 'Enter up to 50 characters.',

    'Error.MerchantContactNameMaxLenPattern': 'Enter up to 50 characters.',
    'Error.MerchantContactDepartMaxLenPattern': 'Enter up to 40 characters.',
    'Error.MerchantTelMinLenPattern': 'Enter up to 10 characters.',
    'Error.MerchantTelMaxLenPattern': 'Enter up to 12 characters.',
    'Error.MerchantEmailMaxLenPattern': 'Enter up to 256 characters.',
    'Error.MerchantCorporatNameMaxLenPattern': 'Enter up to 50 characters.',
    'Error.MerchantCorporatNoMinLenPattern': 'Enter 12 characters.',
    'Error.MerchantCorporatNoMaxLenPattern': 'Enter up to 12 characters.',
    'Error.MerchantPostalMinLenPattern': 'Enter 7 characters.',
    'Error.MerchantPostalMaxLenPattern': 'Enter up to 7 characters.',
    'Error.MerchantNameMaxLenPattern': 'Enter up to 25 characters.',
    'Error.MerchantEnglishNameMaxLenPattern': 'Enter up to 100 characters.',

    'Error.MerchantPostalMaxLenPattern': 'Enter up to 7 characters.',
    'Error.MerchantAdressMaxLenPattern': 'Enter up to 100 characters.',
    'Error.MerchantTelFaxMinLenPattern': 'Enter to 10 characters.',
    'Error.MerchantTelFaxMaxLenPattern': 'Enter up to 12 characters.',
    'Error.MerchantCapitalMaxLenPattern': 'Please enter up to 9 digits.',
    'Error.MerchantAnnualSaleMaxLenPattern': 'Please enter up to 9 digits.',
    'Error.MerchantEmployeesNumberMaxLenPattern': 'Please enter up to 5 digits.',
    'Error.MerchantTempNumberMaxLenPattern': 'Please enter up to 4 digits.',
    'Error.MerchantBusinessContentMaxLenPattern': 'Enter up to 500 characters.',
    'Error.MerchantExternalLinkCdMaxLenPattern': 'Enter up to 6 characters.',

    'Error.MerchantDelegateNameMaxLenPattern': 'Enter up to 50 characters.',
    'Error.MerchantDelegatePostalMinLenPattern': 'Enter 7 characters.',
    'Error.MerchantDelegatePostalMaxLenPattern': 'Enter up to 7 characters.',
    'Error.MerchantDelegateAdressMaxLenPattern': 'Enter up to 100 characters.',
    'Error.MerchantDelegateTelMinLenPattern': 'Enter 10 characters.',
    'Error.MerchantDelegateTelMaxLenPattern': 'Enter up to 12 characters.',

    'Error.MerchantFinancialNameMaxLenPattern': 'Enter up to 50 characters.',
    'Error.MerchantFinancialCdMinLenPattern': 'Enter 3 characters.',
    'Error.MerchantFinancialCdMaxLenPattern': 'Enter up to 3 characters.',
    'Error.MerchantFinancialBranchNameMaxLenPattern': 'Enter up to 50 characters.',
    'Error.MerchantFinancialBranchNoMaxLenPattern': 'Enter up to 3 characters.',
    'Error.MerchantFinancialAccountNoMinLenPattern': 'Enter 7 characters.',
    'Error.MerchantFinancialAccountNoMaxLenPattern': 'Enter up to 7 characters.',
    'Error.MerchantFinancialAccountHolderMaxLenPattern': 'Enter up to 50 characters.',

    // �{�^������
    'Button.Save': 'Save',
    'Button.Back': 'Back',
    'Button.Confirm': 'Confirm',
    'Button.Next': 'Next',
    'Button.Application': 'Apply',
    'Button.AutoInput': 'Auto Input',
    'Button.Delete': 'Delete',
    'Button.ApplicationOK': 'Application OK',
    'Button.Edit': 'Edit',
    'Button.Update': 'Update',
    'Button.Register': 'Register',
    'Button.Apply': 'Apply',
    'Button.ClosePage': 'Close this page',
    'Button.AddFeeSettings': 'Add Fee Settings',
    'Button.DownloadCSV': 'Download CSV',
    'Button.UnprocessedElapse': 'Elapse',
    'Button.UnprocessedCarryOver': 'CarryOver',
    'Button.Download': 'Download',
    'Button.Search': 'Search',
    'Button.AddSetting': 'Add Point Setting',
    'Button.CancellationApplication': 'Cancellation Application',
    'Button.Cancellation': 'Cancellation',
    'Button.SkipAccountEntry': 'Skip account entry',

    //Menu description
    'Menu.Notice': 'Notice',
    'Menu.TradeManagement': 'TradeManagement',
    'Menu.Adjustment': 'Adjustment',
    'Menu.Profile': 'Profile',
    'Menu.Administration': 'Administration',
    'Menu.Other': 'Other',

    //Adjustment Sub Menu description
    'Menu.ListDownload': 'ListDownload',
    'Menu.ConfirmPayment': 'ConfirmPayment',
    //'Menu.Financial': 'Financial',
    'Menu.BankPayment': 'BankPayment',
    'Menu.CreditPayment': 'CreditPayment',
    'Menu.FeeList': 'FeeList',

    //Administration Sub Menu description
    'Menu.Acquirer': 'Acquirer',
    'Menu.Merchant': 'Merchant',
    'Menu.Shop': 'Shop',
    'Menu.Terminal': 'Terminal',
    'Menu.Point': 'Point',
    'Menu.Account': 'Account',
    'Menu.SalesPromotion': 'SalesPromotion',
    'Menu.Fee': 'Fee',

    //Other Sub Menu description
    'Menu.TermsOfService': 'TermsOfService',
    'Menu.Logout': 'LogOut',

    //Point Sub Menu description
    'Menu.PointManagement': 'PointManagement',
    'Menu.PointAggregate': 'PointAggregate',
    'Menu.FeeManagement': 'FeeManagement',

    //Fee Sub Menu description
    'Menu.MerchantFee': 'MerchantFee',
    'Menu.SettlementAgentFee': 'SettlementAgentFee',

    //Default Table description
    'Table.SearchPlaceholder': 'Search',
    'Table.EmptyDataSourceMessage': 'No records to display',
    'Table.Action': 'Action',

    //Notice
    'Notice.Title': 'Notice',

    //Trade
    'Trade.Title': 'Trade',
    'Trade.SubTitle': 'SubTitle',
    'Trade.ResultsTitle': 'ResultsTitle',
    'Trade.Search': 'Search',
    'Trade.SearchStartDate': 'SearchStartDate',
    'Trade.SearchEndDate': 'SearchEndDate',
    'Trade.SearchStartAmount': 'SearchStartAmount',
    'Trade.SearchEndAmount': 'SearchEndAmount',
    'Trade.SearchUnfinishType': 'UnfinishType',
    'Trade.ResultsDownload': 'ResultsDownload',
    'Trade.TransactionDt': 'TransactionDate',
    'Trade.MerchantName': 'MerchantName',
    'Trade.MerchantType': 'MerchantType',
    'Trade.MerchantType.Acquirer': 'Acquirer',
    'Trade.MerchantType.General': 'General',
    'Trade.ShopName': 'ShopName',
    'Trade.Cancel': 'Cancel',
    'Trade.TransactionType': 'TransactionType',
    'Trade.TransactionType.Fixed': 'Fixed',
    'Trade.TransactionType.Cancel': 'Cancel',
    'Trade.TransactionType.Charge': 'Charge',
    'Trade.TransactionType.OkiKoroReserve': 'Move to Card (Reserve)',
    'Trade.TransactionType.OkiKoro': 'Move to Card',
    'Trade.TransactionType.OkiKoroExpiredRecovery': 'Move to Card (ExpiredRecovery)',
    'Trade.TransactionType.OkiKoroUnfinishedRecovery': 'Move to Card (UnfinishedRecovery)',
    'Trade.TransactionType.OkiKoroCancelExpired': 'Cancel Move to Card (Expired)',
    'Trade.TransactionType.OkiKoroCancel': 'Cancel Move to Card',
    'Trade.TransactionType.OkiKoroCancelCardExchange': 'Cancel Move to Card (CardExchange)',
    'Trade.TransactionType.OkiKoroCancelRecovery': 'Move to Card (CancelRecovery)',
    'Trade.TransactionType.SmaKoroReserve': 'Move to SmartOKICA (Reserve)',
    'Trade.TransactionType.SmaKoro': 'Move to SmartOKICA',
    'Trade.TransactionType.SmaKoroExpiredRecovery': 'Move to SmartOKICA (ExpiredRecovery)',
    'Trade.TransactionType.SmaKoroUnfinishedRecovery': 'Move to SmartOKICA (UnfinishedRecovery)',
    'Trade.TransactionType.SmaKoroCancelExpired': 'Cancel Move to SmartOKICA (Expired)',
    'Trade.TransactionType.SmaKoroCancel': 'Cancel Move to SmartOKICA',
    'Trade.TransactionType.SmaKoroCancelCardExchange': 'Cancel Move to SmartOKICA (CardExchange)',
    'Trade.TransactionType.SmaKoroCancelRecovery': 'Move to SmartOKICA (CancelRecovery)',
    'Trade.TransactionType.OkiCharge': 'CardCharge',
    'Trade.TransactionType.OkiChargeCancel': 'CardChargeCancel',
    'Trade.TransactionType.OkiFixed': 'CardPayment',
    'Trade.TransactionType.OkiCancel': 'CardPaymentCancel',
    'Trade.TransactionType.PointReduce': 'PointReduce',

    'Trade.AccountType': 'AccountType',
    'Trade.AccountType.SmartOKica': 'SmartOKica',
    'Trade.AccountType.OkicaCard': 'OkicaCard',
    'Trade.AccountType.CreditCard': 'CreditCard',
    'Trade.AccountType.Bank': 'Bank',
    'Trade.AccountType.OkicaPoint': 'OkicaPoint',
    'Trade.Unfinish.Unfinished': 'Unfinished',
    'Trade.Unfinish.Eliminated': 'Eliminated',
    'Trade.Unfinish.Failed': 'Failed',
    'Trade.Unfinish.Finished': 'Finished',
    'Trade.DebitTitle': 'DebitTitle',
    'Trade.DebitAccountType': 'DebitAccountType',
    'Trade.DebitAmount': 'DebitAmount',
    'Trade.CreditTitle': 'CreditTitle',
    'Trade.CreditAccountType': 'CreditAccountType',
    'Trade.CreditAmount': 'CreditAmount',
    'Trade.Remarks': 'Remarks',
    'Trade.PaymentNo': 'PaymentNo',
    'Trade.TerminalId': 'TerminalId',
    'Trade.Unfinish': 'Unfinish',
    'Trade.UnfinishEliminatedDate': 'UnfinishEliminatedDate',
    'Trade.PaymentAgencyName': 'PaymentAgencyName',
    'Trade.CreditCardGmoForward': 'CreditCardGmoForward',
    'Trade.CreditCardGmoApprove': 'CreditCardGmoApprove',
    'Trade.CreditCardGmoTranId': 'CreditCardGmoTranId',
    'Trade.CreditCardGmoTranDate': 'CreditCardGmoTranDate',
    'Trade.PaymentBillNumber': 'PaymentBillNumber',
    'Trade.PaymentCancelTransactionId': 'PaymentCancelTransactionId',
    'Trade.Status': 'Status',
    'Trade.Status.Processing': 'Processing',
    'Trade.Status.Complete': 'Complete',
    'Trade.Status.Failure': 'Failure',
    'Trade.Amount': 'Amount',
    'Trade.TransactionId': 'TransactionId',
    'Trade.CardIdi': 'CardIdi',
    'Trade.CardDtlSeq': 'CardDtlSeq',
    'Trade.CardDtlSeqLoopCnt': 'CardDtlSeqLoopCnt',
    'Trade.CardDtlFinishDt': 'CardDtlFinishDt',

    //ListDownload
    'ListDownload.Title': 'ListDownload',
    //ConfirmPayment
    'ConfirmPayment.Title': 'ConfirmPayment',
    //Financial
    'Financial.Title': 'Financial',
    //FeeList
    'FeeList.Title': 'FeeList',

    //Profile
    'Profile.Title': 'Profile',

    //Acquirer
    'Acquirer.Title': 'Acquirer',
    'Acquirer.Create': 'Acquirer application',
    'Acquirer.Search': 'Search',
    'Acquirer.Status': 'Status',
    'Acquirer.Name': 'Acquirer Name',
    // application details
    'Acquirer.ApplicationDetails': 'Acquirer Application Details',
    'Acquirer.Cancellation': 'Acquirer Cancellation',

    //Text field labels 
    'Label.Title': 'Ex) ',
    'Label.ShopCd1': 'Please enter within 13 digits',
    'Label.ShopCd2': 'Please enter within 4 digits',
    'Label.ShopCd3': 'Please enter within 6 digits',
    'Label.ShopCd4': 'Please enter within 6 digits',

    //Merchant
    'Merchant.Title': 'Merchant',
    'Merchant.Name': 'Merchant Name',
    //Member store application (new)
    'Merchant.Create': 'Merchant Application',
    'Merchant.Type': 'Merchant Type',
    'Merchant.Status': 'Status',
    'Merchant.Status.Applying': 'Applying',
    'Merchant.Status.CheckPassed': 'CheckPassed',
    'Merchant.Status.Registered': 'Registered',
    'Merchant.Status.CancelletionApplying': 'CancelletionApplying',
    'Merchant.Status.Cancel': 'Cancel',
    'Merchant.ContactName': 'Contact Name',
    'Merchant.ContactNameInFurigana': 'Contact Name (Furigana)',
    'Merchant.PhoneNumber': 'Phone Number',
    'Merchant.MailAddress': 'Mail Address',
    'Merchant.BusinessForm': 'Business Type',
    'Merchant.Corporate': 'Corporate',
    'Merchant.IndividualBusiness': 'Individual Business',
    'Merchant.CorporateName': 'Corporate Name',
    'Merchant.CorporateNameInFurigana': 'Corporate Name (Furigana)',
    'Merchant.CorporateNumber': 'Corporate Number',
    "Merchant.StoreCodeLevel1": "Store identification code (level 1)",
    "Merchant.StoreCodeLevel2": "Store identification code (level 2)",
    "Merchant.CorporateCodeType": 'Corporate Code Type',
    "Merchant.CorporateCodeTypeOkica": 'OKICA',
    "Merchant.CorporateCodeTypeJPQR": 'JPQR',
    'Merchant.NameInEng': 'Merchant Name (English)',
    //Merchant step names  
    "Merchant.StepOne": 'Contact information',
    "Merchant.StepTwo": 'Merchant information',
    "Merchant.StepThree": 'Acquirer information',
    "Merchant.StepFour": 'Bank information ',
    "Merchant.StepFive": 'Fee information',
    "Merchant.StepSix": 'Account information',
    //Merchant Step One Fields
    'Merchant.StepOneTitle': 'Enter contact information',
    'Merchant.FullName': 'Full name',
    'Merchant.FullNameFurigana': 'Full name (Furigana)',
    'Merchant.PhoneNumber': 'Phone Number',
    'Merchant.Mail': 'Mail Address',
    'Merchant.Department': 'Department',
    //Merchant Step Two Fields
    'Merchant.StepTwoTitle': 'Enter Merchant information',
    //some fields name are same as above 
    'Merchant.Place': 'Place',
    'Merchant.PostalCode': 'Postal Code',
    'Merchant.FaxNumber': 'FAX Number',
    'Merchant.Capital': 'Capital',
    'Merchant.AnnualSales': 'Annual Sales',
    'Merchant.EstablishDate': 'Date of Establishment',
    'Merchant.NoOfEmployees': 'Number of Employees',
    'Merchant.NoOfStores': 'Number of Stores',
    'Merchant.IndustryCategory': 'Industry category',
    'Merchant.IndustrySubCategory': 'Industry sub category',
    'Merchant.BusinessDetail': 'Business Details',
    //Merchant Step Three Fields
    'Merchant.StepThreeTitle': 'Enter Acquirer information',
    //some fields name are same as in step one
    'Merchant.BirthDate': 'Date of Birth',
    'Merchant.Address': 'Address',
    'Merchant.Sex': 'Sex',
    'Merchant.SexMale': 'Male',
    'Merchant.SexFemale': 'Female',
    //Merchant Step Four Fields
    'Merchant.StepFourTitle': 'Enter Bank information',
    'Merchant.BankName': 'Bank Name',
    'Merchant.BankCode': 'Banck Code',
    'Merchant.BranchName': 'Branch Name',
    'Merchant.BranchNumber': 'Branch Number',
    'Merchant.AccountType': 'Account Type',
    'Merchant.AccountTypeSavings': 'Savings',
    'Merchant.AccountTypeCurrent': 'Current',
    'Merchant.AccountNumber': 'Account Number',
    'Merchant.AccountHolder': 'Account Holder Name',
    'Merchant.AccountHolderFurigana': 'Account Holder Name (Furigana)',
    'Merchant.ExternalLinkCd': 'external link cd',
    //Merchant Step Five Fields
    'Merchant.StepFiveTitle': 'Enter fee information',
    'Merchant.Period': 'Period',
    'Merchant.Shop': 'Shop',
    'Merchant.GeneralStore': 'General Store',
    'Merchant.Taxi': 'Taxi',
    'Merchant.Retail': 'Retail',
    'Merchant.Charge': 'Charge',
    'Merchant.SystemFeeRate': 'System Fee Rate',
    'Merchant.OKICACardPayment': 'OKICA Card payment',
    'Merchant.QRBalanceSettlement': 'QR Balance Settlement',
    'Merchant.BrandCharge': 'Brand Charge',
    'Merchant.ChargeCommissionRate': 'Charge Commission Rate',
    'Merchant.OKICACardCharge': 'OKICA Card Charge',
    'Merchant.OKICACardValue': 'OKICA Card Value',
    'Merchant.CreditFeeRate': 'Credit Fee Rate',
    'Merchant.SystemFee': 'System Fee',
    'Merchant.BankChargeRate': 'Bank Charge Rate',
    'Merchant.PaymentCycle': 'Payment Cycle',
    'Merchant.PaymentCycle1': 'Once a month',
    'Merchant.PaymentCycle2': 'Two times a month',
    'Merchant.PaymentCycle3': 'Four times a month',
    'Merchant.FromDate': 'Start Date',
    'Merchant.ToDate': 'End Date',
    //Merchant Step Six Fields
    'Merchant.StepSixTitle': 'Enter account information',
    'Merchant.AccountName': 'Account Name',
    'Merchant.Password': 'Password',
    'Merchant.Division': 'Division',
    'Merchant.DivisionName': 'Representative member store',
    // Merchant application details
    'Merchant.ConfirmApplicationDetails': 'Confirm Application Details',
    'Merchant.HelperTextOK': 'To apply your application, click the "OK" button.',
    'Merchant.HelperTextDelete': 'To delete the application details, click the "Delete" button.',
    'Merchant.ApplicationDetails': 'Merchant Application Details',
    //Merchant resgistration completed 
    'Merchant.MemberStoreInfo': 'Merchant information',
    //Merchant detail edit (update message)
    'Merchant.HelperUpdateText': 'Edit the item you want to change and click the [update] button.',
    // Confirmation screen (step seven)
    'Merchant.ConfirmTitle': 'Confirmation',
    'Merchant.ConfirmDesc': 'Check the entered information and if there is no mistake, click the "Register" button.',
    'Merchant.Notice': 'Notice',
    'Merchant.TransactionManagement': 'Transaction Management',
    'Merchant.ListOfPayments': 'List Of Payments',
    'Merchant.Confirmation': 'Confirmation',
    'Merchant.Profile': 'Profile',
    'Merchant.MerchantManagement': 'Merchant Management',
    'Merchant.StoreManagement': 'Store Management',
    'Merchant.TerminalManagement': 'Terminal Management',
    'Merchant.PointManagement': 'Point Management',
    'Merchant.PointTotal': 'Point Total',
    'Merchant.AccountManagement': 'Account Management',
    'Merchant.EditTitle': 'Merchant Application',
    'Merchant.EditDesc': 'Please enter the information in the form below and click the [Confirm] button.',
    'Merchant.AppDesc': 'Check the entered information and if there is no difference, click the [Apply] button.',
    'Merchant.AppDetails': 'Merchant Application Details',
    'Merchant.ApplicationAcceptance': 'Application acceptance completed',
    'Merchant.ThankYouText': 'Thank you for your application.',
    'Merchant.WaitText': 'Please wait for a while until the examination is completed.',
    'Merchant.ResultText': 'After the examination is completed, the examination result will be sent to your email address.',
    'Merchant.MailText': 'Email Address: ',
    'Merchant.MailFilterText': 'If you have set a mail filter, please set permission to receive smart_okica@okica.jp.',
    'Merchant.ApplicationDetails': 'Application Details',
    'Merchant.Cancellation': 'Merchant Cancellation',
    'Merchant.CancelReason': 'Cancel Reason',
    'Merchant.Cancelletion.Title1': 'When you cancel, all the registered information will be deleted. Please note that it cannot be undone.',
    'Merchant.Cancelletion.Title2': 'Select the reason for cancellation and click the "Cancel" button.',
    'Merchant.CancelReason.1': 'To feel uncomfortable, inconvenient, and anxious about this service',
    'Merchant.CancelReason.2': 'There are few customers and opportunities to use this service',
    'Merchant.CancelReason.3': 'If the payment fee for this service is charged, it may not be used',
    'Merchant.CancelReason.4': 'We are dissatisfied with our support center (telephone, email, etc.)',
    'Merchant.CancelReason.5': 'There is dissatisfaction or anxiety about our sales support',
    'Merchant.CancelReason.6': 'To use other QR code payment services',
    'Merchant.CancelReason.7': 'There is resistance and concern about QR code payment (cashless payment) itself',
    'Merchant.CancelReason.8': 'The service is no longer needed due to closures, withdrawal from business, etc.',
    'Merchant.CancelReason.9': 'The service is no longer needed due to changes in management policy, etc.',
    'Merchant.CancelReason.10': 'To change/correct your registration information',
    'Merchant.CancelReason.11': 'Due to duplicate registration (application)',
    'Merchant.CancelReason.12': 'For unintended registration (application)',
    'Merchant.CancelReason.13': 'The representative has passed away',
    'Merchant.CancelReason.99': 'Other',

    //���Z
    'Adjustment.ListOfPayments': 'List Of Payments',
    'Adjustment.YearAndMonth': 'Date',
    'Adjustment.FixedDate': 'Fixed Date',
    'Adjustment.MerchantName': 'Merchant Name',
    'Adjustment.MerchantType': 'Merchant Type',
    'Adjustment.AcquirerName': 'Acquirer Name',
    'Adjustment.AmountPaid': 'Amount Paid',
    'Adjustment.AmountBilled': 'Amount Billed',
    'Adjustment.UnprocessedAmount': 'Unprocessed Amount(Past)',
    'Adjustment.Elapse': 'Elapse',
    'Adjustment.CarryOver': 'Carry Over',
    'Adjustment.Payee': 'Payee',
    'Adjustment.PayOffUnprocessedElapse': 'Incomplete Settlement (Elapse)',
    'Adjustment.PayOffUnprocessedCarryOver': 'Incomplete Settlement (Carry Over)',
    'Adjustment.Type': 'Type',
    'Adjustment.ProcessingDate': 'Processing Date',
    'Adjustment.AmountOfMoney': 'Amount of Money',
    'Adjustment.SettlementByDate': 'Settlement By Date',
    'Adjustment.Date': 'Date',
    'Adjustment.SettlementDetail': 'Settlement Detail',
    'Adjustment.MerchantList': 'Merchant List',
    'Adjustment.PaymentMerchantList': 'Confimation of Payment(Merchant List)',
    'Adjustment.PaymentConfirmation': 'Confimation of Payment',
    'Adjustment.DeadLine': 'Deadline',
    'Adjustment.AccountStatement': 'Account Statement',
    'Adjustment.CSVFileDaily': 'Daily CSV file',
    'Adjustment.CSVFileDetail': 'Detail CSV file',
    'Adjustment.BankPayment': 'Bank Payment',
    'Adjustment.ResultsTitle': 'Result List',
    'Adjustment.CreditPayment': 'Credit Payment',
    'Adjustment.Bank': 'Bank',
    'Adjustment.PaymentAgent': 'Payment Agent',
    'Adjustment.Period': 'Period',
    'Adjustment.TotalFee': 'Total Fee',
    'Adjustment.BankSettlementByDate': 'Bank Settlement By Date',
    'Adjustment.CreditCardPayment': 'Credit Card Payment',
    'Adjustment.CreditSettlementByDate': 'Credit Settlement By Date',
    'Adjustment.Issuer': 'Issuer',
    'Adjustment.Card': 'Card',
    'Adjustment.Brand': 'Brand',
    'Adjustment.QR': 'QR',
    'Adjustment.Charge': 'Charge',
    'Adjustment.Transfer': 'Transfer',
    'Adjustment.System': 'System',
    'Adjustment.FeeList': 'Fee List',

    //���Z-�萔���ꗗ
    'FeeList.List': 'Fee List',
    'FeeList.Date': 'Date',
    'FeeList.AcquirerName': 'Acquirer',
    'FeeList.MerchantName': 'General Merchant',
    'FeeList.AcquirerRow': 'Acquirer',
    'FeeList.GeneralRow': 'General',
    'FeeList.TotalRow': 'Total',
    'FeeList.SystemFee': 'System',
    'FeeList.ChargeFee': 'Charge',
    'FeeList.CreditFee': 'Credit',
    'FeeList.BankFee': 'Bank',
    'FeeList.Card': 'Card',
    'FeeList.Brand': 'Brand',
    'FeeList.Qr': 'QR',
    'FeeList.Charge': 'Charge',
    'FeeList.Exchange': 'Exchange',
    'FeeList.System': 'System',

    //Shop
    'Shop.Title': 'Shop',
    'Shop.MerchantList': 'Shop�iMerchant List�j',
    'Shop.Name': 'Shop Name',
    'Shop.ShopFName': 'Shop Name (Furigana)',
    'Shop.ShopEName': 'Shop Name (English)',
    'Shop.ShopPostalCd': 'Postal Code',
    'Shop.ShopAddress': 'Address (jp)',
    'Shop.ShopEAddress': 'Address (English)',
    'Shop.Latitude': 'Latitude',
    'Shop.Longitude': 'Longitude',
    'Shop.ShopTel': 'TEL Number',
    'Shop.ShopFax': 'FAX Number',
    'Shop.Merchant': 'Merchant',
    'Shop.MerchantName': 'Merchant Name',
    'Shop.ShopType': 'Shop Type',
    'Shop.ShopType.Fixed': 'Fixed',
    'Shop.ShopType.Movable': 'Movable',
    'Shop.ShopCd3': 'Shop Code Level 3',
    'Shop.DealsInfo': 'Deals Information',
    'Shop.Status': 'Status',
    'Shop.Create': 'Create New',
    'Shop.CreateTitle': 'New Shop',
    'Shop.CreateDesc': 'Please enter your store information in the form below and click the [Confirm] button.',
    'Shop.ConfirmTitle': 'Confirmation',
    'Shop.ConfirmDesc': 'Check the entered information and if there is no mistake, click the [Register] button.',
    'Shop.EditTitle': 'Edit Shop',
    'Shop.EditDesc': 'Edit the item you want to change and click the [Update] button.',
    'Shop.ShopEntryStep1Title': 'Shop information',
    'Shop.ShopEntryStep2Title': 'Account information',
    'Shop.BulkRegistration': 'BulkRegistration',

    //profile
    'Shop.Information': 'Shop information',

    //Terminal
    'Terminal.Title': 'Terminal',
    'Terminal.Id': 'TerminalId',
    'Terminal.InstallId': 'InstallId',
    'Terminal.ModelCd': 'TerminalModelCd',
    'Marchine.Id': 'MarchineId',
    'Shop.Name': 'Shop Name',
    'Installed': 'Installed',
    'Terminal.Create': 'TerminalCreate',    
    'Terminal.Type': 'TerminalType',
    'ShopCd4': 'ShopCd4',
    'Terminal.Merchant.Title': 'MerchantTitle',
    'Terminal.Merchant.Name': 'MerchantName',
    'Terminal.Merchant.Type': 'MerchantType',
    'Terminal.Merchant.Type.Acquirer': 'Acquirer',
    'Terminal.Merchant.Type.General': 'General',   
    'Terminal.Shop': 'Shop',
    'Terminal.MachineModelCd': 'MachineModelCd',
    'Terminal.MachineModelCd.Clerk': '1071:Clerk',
    'Terminal.MachineModelCd.Customer': '1072:Customer',
    'Terminal.MachineId': 'MachineId',
    'Terminal.MachineRwCd': 'MachineRwCd',
    'Terminal.ApplyStartDate': 'ApplyStartDate',
    'Terminal.ApplyStopDate': 'ApplyStopDate',
    'Terminal.TerminalType': 'TerminalType',
    'Terminal.TerminalType.Sticker': 'Sticker',
    'Terminal.TerminalType.TerminalQr': 'QR',
    'Terminal.TerminalType.TerminalCard': 'TerminalCard',
    'Terminal.TerminalType.TerminalCardQr': 'TerminalCardQr',
    'Terminal.TerminalType.Tablet': 'Tablet',
    'Terminal.ShopCd4': 'ShopCd4',
    'Terminal.MerchantOrgInfo': 'MerchantOrgInfo',
    'Terminal.IsInstalled': 'IsInstalled',
    'Terminal.IsInstalled.Notinstalled': 'Notinstalled',
    'Terminal.IsInstalled.Installed': 'Installed',
    'Terminal.IsCharge': 'IsCharge',
    'Terminal.IsCharge.Notavailable': 'Notavailable',
    'Terminal.IsCharge.Available': 'Available',
    'Terminal.CreateTitle': 'Enter Terminal information',
    'Terminal.CreateDesc': 'Please enter the information in the form below and click the [Register] button.',
    'Terminal.ConfirmTitle': 'Confirmation',
    'Terminal.ConfirmDesc': 'Check the entered information and if there are no mistakes, click the [Register] button.',

    //PointManagement
    'PointManagement.Title': 'PointManagement',
    'PointManagement.SettingsList': 'Point Settings List',
    'PointManagement.PointKbn': 'PointType',
    'PointManagement.PointKbn.Card': 'Card',
    'PointManagement.PointKbn.Qr': 'QR',
    'PointManagement.PointName': 'Point Name',
    'PointManagement.Period': 'Period',
    'PointManagement.PointRate': 'Point Rate',
    'PointManagement.StartDate': 'Start Date',
    'PointManagement.EndDate': 'End Date',
    'PointManagement.ApplicableCategory': 'Applicable Category',
    'PointManagement.AddPointSetting': 'Add Point Setting',
    'PointManagement.AddDesc': 'Enter the settings of the points to be added and click the [Register] button.',
    'PointManagement.OKICASourceRatio': 'Funding ratio OKICA',
    'PointManagement.MerchantSourceRatio': 'Funding ratio Merchant',
    'PointManagement.Valid': 'Valid',
    'PointManagement.Invalid': 'Invalid',
    'PointManagement.PointSettingDetails': 'Point Setting Details',
    'PointManagement.PointInformation': 'Point Information',
    'PointManagement.EditPointSetting': 'Edit Point Setting',
    'PointManagement.EditDesc': 'Edit the item you want to change and click the [Update] button.',
    'PointManagement.Merchant': 'Merchant',


    //PointAggregate
    'PointAggregate.Title': 'Point Aggregate',
    'PointAggregate.YearAndMonth': 'Date',
    'PointAggregate.PointAggregateList': 'Point Aggregate List',

    //Fee
    'FeeAggregate.Title': 'FeeManagement',

    //FeeManagement
    'FeeManagement.Title': 'Fee Management',
    'FeeManagement.List': 'Fee Settings List',
    'FeeManagement.MerchantName': 'Merchant Name',
    'FeeManagement.MerchantType': 'Merchant Type',
    'FeeManagement.Period': 'Period',
    'FeeManagement.FeeSettingDetails': 'Fee Setting Details',
    'FeeManagement.CreateTitle': 'Fee Setting',
    'FeeManagement.CreateDesc': 'Enter the details of the additional fee commission to be added and click the [Register] button.',
    'FeeManagement.FeeInformation': 'Fee information',
    'FeeManagement.TargetDay': 'Target Day',

    //Account
    'Account.Title': 'Account',
    'Account.MerchantList': 'Account�iMerchant List�j',
    'Account.Name': 'Name',
    'Account.Role': 'Type',
    'Account.Role.SystemAdmin': 'SystemAdmin',
    'Account.Role.Brand': 'Brand',
    'Account.Role.Acquirer': 'Acquirer',
    'Account.Role.Merchant': 'Merchant',
    'Account.Role.Store': 'Store',
    'Account.Org': 'Org',
    'Account.Email': 'Email',
    'Account.Username': 'Username(Email)',
    'Account.Password': 'Password',
    'Account.PasswordRepeat': 'PasswordRepeat',
    'Account.Permission': 'Permission',
    'Account.Status': 'Status',
    'Account.Status.InValid': 'InValid',
    'Account.Status.Valid': 'Valid',
    'Account.Create': 'Create New',
    'Account.CreateTitle': 'New Account',
    'Account.CreateDesc': 'Please enter your account information in the form below and click the [Register] button.',
    'Account.ConfirmTitle': 'Confirmation',
    'Account.ConfirmDesc': 'Check the entered information and if there is no mistake, click the [Register] button.',

    //SalesPromotion
    'SalesPromotion.Title': 'SalesPromotion',

    //TermsOfService
    'TermsOfService.Title': 'TermsOfService',

    //Button description
    'Button.Search': 'Search',
    'Button.ConditionClear': 'ConditionClear',

};
export default en;
